import React from 'react'
import { isAdmin } from '@cpsy-rmap-project/web-core/utils'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Dashboard from './components/organisms/Dashboard'
import { useLogin } from './components/organisms/Login'
import Account from './components/pages/Account'
import { AdminIndexPage, OutsideRequest, Outside } from './components/pages/Admin'
import Help from './components/pages/Help'
import Home from './components/pages/Home'
import NoMatch from './components/pages/NoMatch'
import Privacy from './components/pages/Privacy'
import Search from './components/pages/Search'
import Terms from './components/pages/Terms'
import { Routes, Layouts } from './consts'
import CprmProvider from './utils/provider/CprmProvider'

const ContentWidth = (jsxFn: () => JSX.Element | null) => () =>
  (
    <div
      style={{
        maxWidth: Layouts.MaxMainContentWidth,
        minWidth: Layouts.MinMainContentWidth,
        margin: '0 auto'
      }}
    >
      {jsxFn()}
    </div>
  )

const App: React.FC = () => (
  <BrowserRouter>
    <CprmProvider>
      <Main />
    </CprmProvider>
  </BrowserRouter>
)

export default App

const Main = () => {
  const { fbUser } = useLogin()
  const isAdminUser = isAdmin({ fbUser })

  return (
    <Dashboard>
      <Switch>
        <Route path={Routes.Home.path} exact component={ContentWidth(Home)} />
        <Route path={Routes.Help.path} exact component={ContentWidth(Help)} />
        <Route path={Routes.Search.path} exact component={Search} />
        <Route path={Routes.Account.path} exact component={ContentWidth(Account)} />
        <Route path={Routes.Terms.path} exact component={ContentWidth(Terms)} />
        <Route path={Routes.Privacy.path} exact component={ContentWidth(Privacy)} />
        <Route
          path={Routes.Admin.path}
          render={() => {
            if (!isAdminUser) {
              return (
                <Switch>
                  <Route component={ContentWidth(NoMatch)} />
                </Switch>
              )
            }

            return (
              <Switch>
                <Route path={Routes.Admin.path} exact component={ContentWidth(AdminIndexPage)} />
                <Route path={Routes.Admin_OutsideRequest.path} exact component={ContentWidth(OutsideRequest)} />
                <Route path={Routes.Admin_Outside.path} exact component={ContentWidth(Outside)} />
                <Route component={ContentWidth(NoMatch)} />
              </Switch>
            )
          }}
        />
        <Route component={ContentWidth(NoMatch)} />
      </Switch>
    </Dashboard>
  )
}
